// extracted by mini-css-extract-plugin
module.exports = {"header":"WorkspacesBox_header__2SI16","box":"WorkspacesBox_box__18PAu","node":"WorkspacesBox_node__1IvAV"};